var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "social-schedule-calendar" },
    [
      _c(
        "b-modal",
        {
          staticClass: "modal-edit-social-deliverable",
          attrs: {
            size: "lg",
            "hide-footer": "",
            id: "editSocialModal",
            title: "Edit Social Deliverable",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          },
          on: {
            show: _vm.editSocialModalShown,
            shown: _vm.afterEditSocialModalShown,
            hide: _vm.editSocialModalHidden,
            hidden: _vm.removeRoute
          }
        },
        [
          _c("EditSocialModal", {
            ref: "refEditSocialModal",
            attrs: { allContacts: _vm.allContacts, tabIndex: _vm.tabIndex }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "deliverable-header" },
        [
          _c("HeaderIcon", {
            attrs: {
              totalDeliverableCount: this.allDeliverablesPaginationData.total
                ? this.allDeliverablesPaginationData.total
                : 0,
              totalOutletCount: this.outletCount ? this.outletCount : 0,
              myWeek: false
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("SocialTabs"),
      _vm._v(" "),
      _c("div", { staticClass: "calendar-container" }, [
        _c("div", { ref: "SchedulerComponent", staticClass: "calendar" })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }